import backendInstance from "../utils/axios/backendInstance";

export const downloadFile = async (url) => {
  // url ở đây là đường dẫn đến file trên server, ví dụ '/split-data/Admin/admin1.xlsx'
  const response = await backendInstance.get("/config/download", {
    params: { url }, // axios sẽ gắn ?url=… vào URL
    responseType: "blob",
  });

  // trích filename từ url hoặc từ header
  const filename = url.split("/").pop();
  const blob = new Blob([response.data]);
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
};

export const downloadAdminFile = async (tab) => {
  await downloadFile(`/config/download/admin/${tab}`, `admin${tab}`);
};

export const downloadCustomerFile = async (tab) => {
  await downloadFile(`/config/download/customer/${tab}`, `customer${tab}`);
};

export const slipCustom = async (numTabs, formData) => {
  try {
    const response = await backendInstance.post(
      `/config/split-custom/${numTabs}`,
      formData
    );
    return response.data;
  } catch (error) {
    console.error("Slip custom error:", error);
  }
};

export const checkAllMailAdmin = async () => {
  try {
    const response = await backendInstance.post(`/config/check-mail-admin/all`);
    console.log("Check all mail admin response:", response);

    return response.data;
  } catch (error) {
    console.error("Check all mail admin error:", error);
  }
};

export const checkingAllTab = async () => {
  try {
    const response = await backendInstance.post(`/config/start-checking/all`);
    console.log("Checking all tabs response:", response);

    return response.data;
  } catch (error) {
    console.error("Checking all tab error:", error);
  }
};

export const checkExistCustomerTestFile = async () => {
  try {
    const response = await backendInstance.post(`/config/check-exit-file`);

    return response.data;
  } catch (error) {
    console.error("Check exist customer test file error:", error);
  }
};
